import React, {Component} from 'react'
import {
    Button,
    ButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap'
import RefinamientoModal from './RefinamientoModal'
import AprobarModal from './AprobarModal'
import RejectModal from './RejectModal'
import PartialModal from './PartialModal'
import ChangesModal from './ChangesModal'

class ActionButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            goto: null,
            showModalRefinamiento: false,
            showModalAprobar: false,
            showModalReject: false,
            showModalPartial: false,
            showModalChanges: false,
            isOpen: false,
            buttons: [
                {
                    title: "",
                    color: "",
                    action: ""
                }
            ]
        };
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
    toggleModalRefinamiento() {
        this.setState({
            showModalRefinamiento: !this.state.showModalRefinamiento
        })
    }
    toggleModalAprobar() {
        this.setState({
            showModalAprobar: !this.state.showModalAprobar
        })
    }
    toggleModalReject() {
        this.setState({
            showModalReject: !this.state.showModalReject
        })
    }
    toggleModalPartial() {
        this.setState({
            showModalPartial: !this.state.showModalPartial
        })
    }
    toggleModalChanges() {
        this.setState({
            showModalChanges: !this.state.showModalChanges
        })
    }
    componentWillReceiveProps(nextProps) {
        let status = Number(nextProps.status)
        if (nextProps.isAdmin == 1) {
            switch (status) {
                case 0:
                    this.setState({
                        buttons: [
                            {
                                title: "Iniciar estudio",
                                active: true
                            }
                        ]
                    })
                    break
                case 1:
                    this.setState({
                        buttons: [
                            {
                                title: "Enviar estudio",
                                active: true
                            }
                        ]
                    })
                    break
                case 2:
                    this.setState({
                        buttons: [
                            {
                                title: "Esperando aprobación",
                                active: false
                            }
                        ]
                    })
                    break
                case 3:
                    this.setState({
                        buttons: [
                            {
                                title: "Iniciar producción",
                                active: true
                            }
                        ]
                    })
                    break
                case 4:
                    this.setState({
                        buttons: [
                            {
                                title: "Entregar parcial",
                                onclick: this.toggleModalPartial.bind(this),
                                active: true
                            },
                            {
                                goto: 6,
                                title: "Entregar total",
                                onclick: this.updateStatusDelivered.bind(this),
                                active: true
                            }
                        ],
                    })
                    break
                case 5:
                    this.setState({
                        buttons: [
                            {
                                title: "Entregar parcial",
                                onclick: this.toggleModalPartial.bind(this),
                                active: true
                            },
                            {
                                goto: 6,
                                title: "Entregar total",
                                onclick: this.updateStatusDelivered.bind(this),
                                active: true
                            }
                        ]
                    })
                    break
                default:
                    this.setState({
                        buttons: [
                            {
                                active: false
                            }
                        ]
                    })
            }
        } else {
            switch (status) {
                case 0:
                    this.setState({
                        buttons: [
                            {
                                title: "Enviado a laboratorio",
                                active: false
                            }
                        ]
                    })
                    break
                case 1:
                    this.setState({
                        buttons: [
                            {
                                title: "En estudio",
                                active: false
                            }
                        ]
                    })
                    break
                case 2:
                    this.setState({
                        buttons: [
                            {
                                title: "Aprobar",
                                onclick: this.toggleModalAprobar.bind(this),
                                active: true
                            },
                            {
                                title: "No aceptar presupuesto",
                                active: true,
                                onclick: this.toggleModalReject.bind(this),
                                color: "danger"
                            },
                            {
                                title: "Sugerir cambios",
                                onclick: this.toggleModalChanges.bind(this),
                                active: true
                            }
                        ]
                    })
                    break
                case 3:
                    this.setState({
                        buttons: [
                            {
                                title: "Iniciada producción",
                                active: false
                            }
                        ]
                    })
                    break
                case 4:
                    this.setState({
                        buttons: [
                            {
                                title: "Entregado parcial",
                                active: false
                            }
                        ]
                    })
                    break
                case 5:
                    this.setState({
                        buttons: [
                            {
                                title: "Entregado total",
                                active: false
                            }
                        ]
                    })
                    break
                case 6:
                    this.setState({
                        buttons: [
                            {
                                title: "Refinamiento",
                                onclick: this.toggleModalRefinamiento.bind(this),
                                color: "warning",
                                active: true
                            }
                        ]
                    })
                    break
                default:
                    this.setState({
                        buttons: [
                            {
                                active: false
                            }
                        ]
                    })
            }
        }
    }
    updateStatus() {
        this.props.updateCaso({
            status: Number(this.props.status) + 1,
            id: this.props.casoId
        })
    }
    updateStatusDelivered() {
        this.props.updateCaso({
            status: 6,
            id: this.props.casoId
        })
    }
    updateStatusRejected() {
        this.props.updateCaso({
            status: 8,
            id: this.props.casoId
        })
    }
    renderButtons() {
        if(!this.state.buttons[0].active){
            return null
        }
        if(this.state.buttons.length > 1){
            return (
                <div>
                    <ButtonDropdown
                        isOpen={this.state.isOpen}
                        toggle={this.toggle.bind(this)}
                        className="btn-block"
                    >
                        <Button block
                                id="caret"
                                color="primary"
                                onClick={this.state.buttons[0].onclick || this.updateStatus.bind(this)}>
                            {this.state.buttons[0].title}
                        </Button>
                        <DropdownToggle caret color="primary" />
                        <DropdownMenu>
                            {this.state.buttons.map((button, i)=>{
                                if(i != 0){
                                    return (<DropdownItem
                                        key={"button_"+i}
                                        onClick={button.onclick}
                                    >
                                        {button.title}
                                    </DropdownItem>)
                                }
                            })}
                        </DropdownMenu>
                    </ButtonDropdown>
                    <RefinamientoModal
                        casoId={this.props.casoId}
                        toggler={this.toggleModalRefinamiento.bind(this)}
                        show={this.state.showModalRefinamiento}
                    />
                    <ChangesModal
                        casoId={this.props.casoId}
                        toggler={this.toggleModalChanges.bind(this)}
                        show={this.state.showModalChanges}
                        action={this.props.addComment.bind(this)}
                    />
                    <AprobarModal
                        casoId={this.props.casoId}
                        toggler={this.toggleModalAprobar.bind(this)}
                        show={this.state.showModalAprobar}
                        action={this.updateStatus.bind(this)}
                    />
                    <RejectModal
                        casoId={this.props.casoId}
                        toggler={this.toggleModalReject.bind(this)}
                        show={this.state.showModalReject}
                        action={this.updateStatusRejected.bind(this)}
                    />
                    <PartialModal
                        casoId={this.props.casoId}
                        toggler={this.toggleModalPartial.bind(this)}
                        show={this.state.showModalPartial}
                        action={this.updateStatus.bind(this)}
                        partialDelivery={this.props.partialDelivery}
                    />
                </div>
            )
        } else {
            return (
                <div>
                    <Button
                        color={this.state.buttons[0].color || "primary"}
                        block
                        onClick={this.state.buttons[0].onclick || this.updateStatus.bind(this)}
                    >
                        {this.state.buttons[0].title}
                    </Button>
                    <RefinamientoModal
                        casoId={this.props.casoId}
                        toggler={this.toggleModalRefinamiento.bind(this)}
                        show={this.state.showModalRefinamiento}
                    />
                </div>
            )
        }
    }

    render() {
        return (
            <div>
                {this.renderButtons()}
            </div>
        )
    }

}
export default ActionButton


// WEBPACK FOOTER //
// ./resources/assets/js/components/viewer/ActionButton.jsx